export const MAX_FILE_SIZE_BYTES = 50 * 1024 * 1024;
export const ALLOWED_EXTENSIONS = ["csv", "xlsx"];
export const ALLOWED_ACCEPT = ".csv,.xlsx,text/csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

export const BATCH_STATUS = {
  PROCESSING: "processing",
  DONE: "done",
  WARNING: "warning",
  FAILED: "failed",
};

export const RATE_VALUES = [
  { value: "LANEHAUL", label: "Lanehaul" },
  { value: "MINIMAL", label: "Minimal" },
  { value: "AVERAGE", label: "Average" },
  { value: "MAXIMAL", label: "Maximal" },
  { value: "FULL", label: "Full" },
];

export const DATE_RANGES = [
  { value: "SEVEN_DAYS", label: "7 days" },
  { value: "THIRTY_DAYS", label: "30 days" },
  { value: "THREE_MONTHS", label: "3 months" },
  { value: "SIX_MONTHS", label: "6 months" },
  { value: "TWELVE_MONTHS", label: "12 months" },
];

export const MAX_DATE_RANGES = 3;

export const GEOGRAPHY_LEVELS = [
  { value: "ZIP", label: "ZIP" },
  { value: "MARKET", label: "Market" },
];

export const RATE_MODES = [
  { value: "FLAT", label: "Flat" },
  { value: "PER_MILE", label: "Per mile" },
];
